var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4583 0 0 13.4583 0 30C0 46.5417 13.4583 60 30 60C46.5417 60 60 46.5417 60 30C60 13.4583 46.5417 0 30 0Z",
    fill: "#2A2B79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005 2.5C45.1641 2.5 57.5006 14.8364 57.5006 30C57.5006 36.0361 55.5227 41.6061 52.213 46.1463C51.9239 45.9582 51.6381 45.7866 51.3482 45.6372C46.3385 43.0653 38.5674 40 30.0005 40C21.4337 40 13.6626 43.0653 8.65166 45.6385C8.36256 45.7873 8.07721 45.9584 7.78822 46.1463C4.4785 41.6058 2.50049 36.0361 2.50049 30C2.50049 14.8364 14.8369 2.5 30.0005 2.5Z",
    fill: "#F8F9FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 57.5C21.7779 57.5 14.4074 53.8545 9.36377 48.1164C9.50756 48.0294 9.65252 47.9347 9.79479 47.8613C14.5592 45.415 21.9322 42.5 29.9999 42.5C38.0676 42.5 45.4405 45.415 50.2037 47.8602C50.3467 47.934 50.492 48.0288 50.6362 48.1163C45.5924 53.8543 38.2219 57.5 29.9999 57.5Z",
    fill: "#2A2B79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37.5C38.2843 37.5 45 30.7843 45 22.5C45 14.2157 38.2843 7.5 30 7.5C21.7157 7.5 15 14.2157 15 22.5C15 30.7843 21.7157 37.5 30 37.5Z",
    fill: "#2A2B79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M41.3362 55.0301C44.9065 53.3986 48.0741 51.0318 50.6369 48.1163C50.4928 48.0288 50.3474 47.934 50.2045 47.8602C45.4413 45.415 38.0682 42.5 30.0006 42.5C29.6144 42.5 29.2388 42.5368 28.856 42.5497L41.3362 55.0301Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005 35.0001C36.9041 35.0001 42.5006 29.4036 42.5006 22.5C42.5006 15.5965 36.9041 10 30.0005 10C23.097 10 17.5005 15.5965 17.5005 22.5C17.5005 29.4036 23.097 35.0001 30.0005 35.0001Z",
    fill: "#2A2B79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.7021 11.9839C37.1915 13.321 37.5009 14.7454 37.5009 16.25C37.5009 23.1424 31.8934 28.75 25.0008 28.75C22.5309 28.75 20.2405 28.0072 18.2996 26.766C20.0522 31.5544 24.6127 35 30.0007 35C36.8932 35 42.5008 29.3923 42.5008 22.4999C42.5009 18.0773 40.1775 14.2065 36.7021 11.9839Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4583 0 0 13.4583 0 30C0 46.5417 13.4583 60 30 60C46.5417 60 60 46.5417 60 30C60 13.4583 46.5417 0 30 0Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.812,
    y1: 17.326,
    x2: 57.1884,
    y2: 42.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b6d513175f3c78c6e1551dfe04829e89.svg";
export { ForwardRef as ReactComponent };